import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Payload {
  email: string;
}

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<undefined>('POST', `/api/v2/action/forgot-password`, { data });
